/*
 * Styles for the shared search input.
 *
 * Imported by agwa-search.ts via `?inline` + `unsafeCSS`.
 *
 * COLOUR RULE: no raw hex. The resting lift comes from --agwa-elevation-1
 * rather than a literal black shadow, which would read as depth on white and
 * as nothing at all on a dark base.
 */

:host {
  display: inline-block;
  max-width: var(--agwa-search-max-width, 360px);
}
sl-input::part(base) {
  box-shadow: var(--agwa-elevation-1);
}
:host([hidden]) {
  display: none !important;
}
